import { Action } from '../types/action';
import { ActionWithAnswer } from '../types/action-with-answer';

export const useAnswer =
  <TAnswer, TReturn = void>(
    cb: (answer: TAnswer) => Action<TReturn>
  ): ActionWithAnswer<TAnswer, TReturn> =>
  (answer: TAnswer) =>
    cb(answer)();
